import React from 'react'

export default function UserProfile() {
        return (
                <div>
                        User Profile
                </div>
        )
}


